import { type PropsWithChildren } from 'react';

const NoLayout: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export default NoLayout;
